module.exports = __webpack_public_path__ + "img/party-popper.b5e51fdc.svg";